( function( $ ) {
    //reveal the contact form after click
    $('.basistraining-contact-form .contact-form').hide();
        $('.contact-form-show').on('click', function(e) {
            e.preventDefault();
            $('.basistraining-contact-form .contact-form').show();
            $('.contact-form-show').hide();
        });

    // ajax form handling
    $('#contact-form').on('submit', function(e) {
        e.preventDefault();

        var form = $(this);
        if (form.hasClass('form-sent')) {
            return;
        }

        var data = {
            'action' : 'training_contact_form',
            'name'   : $('.input-name').val(),
            'email'  : $('.input-email').val(),
            'message': $('.input-message').val()
        };

        var ok = Object.keys(data).reduce(function(acc, key) {
            var value = data[key];
            if (!value) {
                form.find('.form-group-' + key).addClass('error');
                return false;
            } else if (key === 'email' && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))) {
                form.find('.form-group-' + key).addClass('error');
                return false;
            } else {
                form.find('.form-group-' + key).removeClass('error');
                return acc;
            }
        }, true);

        if (ok) {
            form.removeClass('form-error');

            var contactRequest = $.ajax({
                url: themevars.ajaxurl,
                method: 'POST',
                data: data
            });

            contactRequest.error(function() {
                //foutmeldingen
                form.addClass('form-error');
            });

            contactRequest.success(function() {
                // form vervangen/aanvullen met successmelding
                form.removeClass('form-error');
                form.addClass('form-sent');
                form.find('input, textarea, button').prop('disabled', true);
            });
        }
    });
} )( jQuery );